const ErrorView = () => {
  // This component will be displayed when an error boundary catches an error
  return <h1>Something went wrong</h1>;
};

export default ErrorView;
